// Getter functions for mutable defaults
export function getDefaultFilter() {
  return {
    txt: '',
    country: null,
    dateAddedStart: '',
    dateAddedEnd: '',
    active: ACTIVE_STATUSES.ACTIVE,
    dpfFound: DPF_FOUND_STATUSES.ALL,
    aiServices: AI_SERVICES_STATUSES.ALL,
  }
}

export function getDefaultTableState() {
  return {
    sortBy: 'dateAdded',
    descending: true,
    page: 1,
    rowsPerPage: 15,
  }
}

// Filter status constants
export const ACTIVE_STATUSES = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  ALL: 'all',
}

export const DPF_FOUND_STATUSES = {
  FOUND: 'found',
  NOT_FOUND: 'not_found',
  ALL: 'all',
}

export const AI_SERVICES_STATUSES = {
  PROVIDES: 'provides',
  DOES_NOT_PROVIDE: 'does_not_provide',
  ALL: 'all',
}

// Filter metadata
export const FILTERABLE_FIELDS = [
  'txt',
  'country',
  'dateAddedStart',
  'dateAddedEnd',
  'active',
  'dpfFound',
  'aiServices',
]

export const FILTER_LABELS = {
  active: 'Company status',
  txt: 'Company name',
  dateAddedStart: 'Date added - Start',
  dateAddedEnd: 'Date added - End',
  country: 'Country',
  dpfFound: 'Data privacy framework',
  aiServices: 'AI services',
}

export const FILTER_OPTIONS = {
  active: [
    {
      label: 'Active (default)',
      value: ACTIVE_STATUSES.ACTIVE,
    },
    {
      label: 'Archived',
      value: ACTIVE_STATUSES.ARCHIVED,
    },
    {
      label: 'All',
      value: ACTIVE_STATUSES.ALL,
    },
  ],
  dpfFound: [
    {
      label: 'Found',
      value: DPF_FOUND_STATUSES.FOUND,
    },
    {
      label: 'Not found',
      value: DPF_FOUND_STATUSES.NOT_FOUND,
    },
    {
      label: 'All (Default)',
      value: DPF_FOUND_STATUSES.ALL,
    },
  ],
  aiServices: [
    {
      label: 'Provides',
      value: AI_SERVICES_STATUSES.PROVIDES,
    },
    {
      label: 'Does not provide',
      value: AI_SERVICES_STATUSES.DOES_NOT_PROVIDE,
    },
    {
      label: 'All (Default)',
      value: AI_SERVICES_STATUSES.ALL,
    },
  ],
}
